import { useSelector } from 'react-redux';

import { ATInternetCustomObjectField } from './constants';
import { currentUserUuidSelector } from '@xarvio/frontend-core-state/lib/auth/selectors';

export const useGetGlobalVariablesValues = () => {
  const userUuid = useSelector(currentUserUuidSelector);

  return (globalVariables: ATInternetCustomObjectField[]) => {
    const values = {};

    for (const variable of globalVariables) {
      switch (variable) {
        case ATInternetCustomObjectField.USER_ID:
          values[ATInternetCustomObjectField.USER_ID] = userUuid;
      }
    }

    return values;
  };
};
